module.exports = __webpack_public_path__ + "static/img/nav-1.6fbf2f11.svg";